import { ThemeConfigType, FigmaModesType } from '@themes/themeTypes';
import { parseFigmaModes } from '@themes/utils';
import variablesJSON from '@account_module/theme/figma_variables.json';

const colorModes = variablesJSON.collections.filter(
  (collection) => collection.name === 'colors'
)?.[0].modes;

const figmaVariables = parseFigmaModes(colorModes as FigmaModesType[]);

export const accountThemeCfg: ThemeConfigType = {
  light: {
    '--text-success': '#29826E',
    '--text-light': '#F1F3F9',
    '--text-accent': '#5364D3',
    '--text-dark-blue': '#000061',
    '--text-dark-accent': '#192576',

    '--error': '#CD3C3C',
    '--bg-error-transparent': 'rgba(205, 60, 60, 0.1)',
    '--warning': '#B23F3F',
    '--info': '#0009E8',

    '--bg-secondary': '#FAFBFC',
    '--bg-selected': '#F4F4F6',
    '--bg-muted': '#E8EFFB',
    '--bg-special': '#EFEFF1',
    '--bg-accent-transparent': 'rgba(0, 9, 232, 0.05)',
    '--bg-light-blue': '#E9F4FB',
    '--bg-white-transparent': 'rgba(255, 255, 255, 0.8)',
    '--bg-muted-transparent': 'rgba(223, 225, 229, 0.5)',
    '--accent': '#5364D3',
    '--accent2': '#0009E8',
    '--bg-text-highlight2': '#FF990080',
    '--bg-text-highlight': '#FAFF0080',

    '--bg-garm-gradient-primary': '#2B40CC54',
    '--bg-garm-gradient-secondary': '#2B40CC00',

    '--muted': '#414753',
    '--muted2': '#6C727E',
    '--muted3': '#BBC0C8',
    '--muted4': '#DFE1E5',
    '--muted5': '#F1F1F3',
    '--text-muted-2': '#6A7181',

    //add missing button colors (filter, risk lvl btn, save/edit view btn, etc.)
    '--btn-primary': '',
    '--btn-toggler-bg': '#0009E8',
    '--btn-toggler-text': '#F1F3F9',

    '--border-secondary': '#E8EFFB',
    '--border-tertiary': '#82AEF0',
    '--border-ruler': '#F2F2F2',
    '--border-garm-card': '#E6EDF9',
    '--border-blue-transparent': 'rgba(35, 132, 194, 0.3)',
    '--border-input-focus': '#7C8EFF',
    '--border-input-focus-transparent': '#7C8EFF66',

    '--fill-primary': '#192576',
    '--fill-secondary': '#F4F4F6',
    '--fill-tertiary': '#4D4F69',
    '--fill-text-primary': '#051129',
    '--fill-btn-toggler': '#F1F3F9',
    '--fill-muted': '#414753',
    '--fill-muted2': '#6C727E',
    '--fill-muted3': '#BBC0C8',
    '--fill-garm-icon': '#090E92',
    '--fill-accent': '#0009E8',
    '--fill-accent2': '#5364D3',
    '--fill-white': '#fff',
    '--fill-warning': '#B23F3F',

    '--stroke-primary': '#414753',
    '--stroke-secondary': '#F4F4F6',
    '--stroke-tertiary': '#4D4F69',
    '--stroke-risk-unrelated-badge-text': '#0F4DAA',
    '--stroke-accent': '#0009E8',
    '--stroke-muted2': '#6C727E',
    '--stroke-muted3': '#BBC0C8',
    '--stroke-text-primary': '#051129',
    '--stroke-error': '#892222',
    '--stroke-btn-toggler': '#F1F3F9',
    '--stroke-white': '#fff',
    '--stroke-dark-accent': '#192576',

    '--table-row': '#FAFBFC',
    '--table-head-row': '#FFF',

    '--card-border': '#DFE1E5',

    '--box-shadow-primary': '0px 1px 25px rgba(93, 93, 97, 0.1)',
    '--box-shadow-secondary': '0px 1px 7px rgba(57, 57, 57, 0.1)',
    '--box-shadow-tertiary': '1px 1px 8px rgba(24, 24, 29, 0.2)',
    '--box-shadow-quaternary': '2px 2px 20px rgba(24, 24, 29, 0.15)',
    '--box-shadow-small': '1px 1px 5px rgba(124, 124, 124, 0.15)',
    '--box-shadow-dropdown': '0px 1px 2px 0px #E7EAEE',

    '--drop-shadow-small': '1px 1px 5px rgba(124, 124, 124, 0.15)',
    ...figmaVariables.light,
  },
  dark: {
    '--text-light': '#FFF',
    '--text-dark-blue': '#000061',

    '--bg-tile-card': '#21232D',
    '--bg-secondary': '#181C20',
    '--bg-muted': '#293347',
    '--bg-light-blue': '#E9F4FB',

    '--bg-garm-gradient-primary': '#2B40CC54',
    '--bg-garm-gradient-secondary': '#2B40CC00',
    '--bg-selected': '#222437',
    '--warning': '#B23F3F',

    '--text-muted2': '#838CAF',
    '--muted3': '#BBC0C8',
    '--muted4': '#DFE1E5',
    '--muted5': '#F1F1F3',
    '--text-muted-2': '#6A7181',

    //add missing button colors (filter, risk lvl btn, save/edit view btn, etc.)
    '--btn-primary': '',
    '--btn-toggler-bg': '#0009E8',
    '--btn-toggler-text': '#F1F3F9',

    '--border-secondary': '#272E34',
    '--border-ruler': '#181C25',
    '--border-blue-transparent': 'rgba(35, 132, 194, 0.3)',

    '--fill-primary': '#FFF',
    '--fill-secondary': '#313246',
    '--fill-tertiary': '#4D4F69',
    '--fill-btn-toggler': '#F1F3F9',

    '--stroke-primary': '#D0D2D7',
    '--stroke-secondary': '#313246',
    '--stroke-tertiary': '#4D4F69',

    '--table-row': '#111212',
    '--table-head-row': '#111212',

    '--card-border': '#181C25',

    '--box-shadow-primary': '0px 4px 4px rgba(0, 0, 0, 0.25)',
    '--box-shadow-secondary': '0px 1px 7px rgba(57, 57, 57, 0.1)',

    ...figmaVariables.dark,
  },
};
